import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FeedbackButtons from '../../../report-ai-assistant-insights/feedback/FeedbackButtons';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InsightComponent = ({
  appUsageTracker,
  insight,
  correlationId,
  report,
  dataset
}) => {
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "row",
    children: [/*#__PURE__*/_jsx(Text, {
      "data-test-id": "report-vis-insights-string",
      children: insight.value
    }), /*#__PURE__*/_jsx(FeedbackButtons, {
      appUsageTracker: appUsageTracker,
      correlationId: correlationId,
      insight: insight,
      marginInlineStart: "200",
      report: report,
      dataset: dataset
    })]
  });
};
export default InsightComponent;